export default {
  add_products: '+ Adaugă produse',
};
